import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {NavigationContentType} from './content.interface';

export interface ContentState {
  readonly navigation?: NavigationContentType;
  readonly navigationError: boolean;
  readonly navigationErrorMsg: string;
  readonly navigationLoading: boolean;
  readonly empireFooter: {
    readonly empireFooterContent?: string;
    readonly empireFooterContentTimestamp?: number;
    readonly empireFooterError: boolean;
    readonly empireFooterErrorMsg: string;
  };
  readonly isHeaderFooterSuppressed: boolean;
}

export const initialState: ContentState = {
  // fewer options by default to prove it's loading. we want this to match production
  // later on though, so it works on the app without internet initially
  navigation: {
    logo: 'https://www.caesars.com/content/dam/caesars-rewards/logos/crw_navigation_logo.png',
    links: [
      {
        title: 'Benefits',
        url: 'https://www.caesars.com/myrewards/benefits-overview',
      },
    ],
  },
  navigationError: false,
  navigationErrorMsg: '',
  navigationLoading: false,
  empireFooter: {
    empireFooterContent: '',
    empireFooterError: false,
    empireFooterErrorMsg: '',
  },
  isHeaderFooterSuppressed: false,
};

const {actions: ContentActions, reducer: ContentReducer} = createSlice({
  name: 'content',
  initialState,
  reducers: {
    fetchNavigation() {},
    fetchNavigationSuccess(
      state,
      action: PayloadAction<NavigationContentType>
    ) {
      state.navigationError = false;
      state.navigationErrorMsg = '';
      state.navigation = action.payload;
    },
    fetchNavigationError(
      state,
      action: PayloadAction<{error: boolean; message: string}>
    ) {
      state.navigationError = action.payload.error;
      state.navigationErrorMsg = action.payload.message;
    },
    fetchEmpireFooterContent() {},
    fetchEmpireFooterContentSuccess(state, action: PayloadAction<string>) {
      state.empireFooter.empireFooterContent = action.payload;
      state.empireFooter.empireFooterContentTimestamp = Date.now();
      state.empireFooter.empireFooterError = false;
      state.empireFooter.empireFooterErrorMsg = '';
    },
    fetchEmpireFooterContentError(
      state,
      action: PayloadAction<{error: boolean; message: string}>
    ) {
      state.empireFooter.empireFooterError = action.payload.error;
      state.empireFooter.empireFooterErrorMsg = action.payload.message;
    },
    checkHeaderFooterSuppression() {},
    suppressHeaderFooter(state, action: PayloadAction<boolean>) {
      state.isHeaderFooterSuppressed = action.payload;
    },
  },
});

export {ContentActions};
export default ContentReducer;
